import React from "react";
import MediaQuery from "react-responsive";

import logo from "../assets/logo_h_black.svg";
import anthorTeam from "../assets/anthor-team.png";

const getMediaQueryStyle = (mediaQuery) => {
  return Object.assign({}, partnerStyle["default"], partnerStyle[mediaQuery]);
}

const Header = () => {
  return (
    <div className="row" id="positions-intro" style={marginTopStyle}>
      <div style={container}>
        <div>
          <img src={logo} alt="logo" style={logoStyle} />
        </div>
        <div style={{ display: "flex" }}>
          <div style={textContainer}>
            <label style={{ color: "#1578D7" }}>
              <b>CAREERS</b>
            </label>
            <h1 style={h1Style}>
              <b>Join us at improving the way people work.</b>
            </h1>
            <span style={textStyle}>
              We’re building the next great gig economy app. We'll scale quickly
              and we have a very challenging road ahead.
            </span>
            <br />
            <span style={textStyleTop}>
              Anthor is a platform that connects companies, stores and
              promoters. Ensuring fully stocked shelves, increase in sales and
              reduction in costs.
            </span>
            <br />
            <span style={textStyleTop}>
              We would love to have you on our team!
            </span>
          </div>
          <MediaQuery minDeviceWidth={1000}>
            <div style={getMediaQueryStyle()}>
              <img src={anthorTeam} alt="equip" />
            </div>
          </MediaQuery>
        </div>
      </div>
    </div>
  );
};

const container = { display: "flex", flexDirection: "column", paddingLeft: "20px", paddingRight: "20px" };
const textContainer = {
  display: "flex",
  flexDirection: "column"
};
const textStyleTop = { maxWidth: "450px", marginTop: "20px" };
const textStyle = { maxWidth: "450px" };
const h1Style = { maxWidth: "600px", fontSize: "3rem" };
const marginTopStyle = { marginTop: "50px" };
const logoStyle = {
  width: "15%",
  minWidth: "80px",
  marginBottom: "100px"
};

const partnerStyle = {
  default: {
    display: "flex"
  },
  "1000": {
    display: "none"
  }
};


export default Header;
